export default "__VITE_ASSET__ba68f602__$_?nuxt_component=async&nuxt_component_name=SvgoScenario__"